import Vue from 'vue'

import { BvDataCenter } from '@dinosband/bv-data-center'
import { mainStore } from '@dinosband/bv-utils'
import { messengerClient } from '@dinosband/bv-messenger-client'

import { MessengerStore } from './messenger-store'
import * as controller from './controller/init-cleanup'

let _userId = -1

export const apolloClient = messengerClient.apolloClient
export const dataCenter = Vue.observable(new BvDataCenter(apolloClient))
export const messengerStore = Vue.observable(new MessengerStore(dataCenter))

async function initForNewUser () {
  if (_userId == mainStore.userId) {
    return
  }
  // controller.cleanup()
  messengerStore.cleanup()
  dataCenter.cleanup()
  _userId = mainStore.userId
}

export async function initMessengerController (limit?: { chatRoomIds: number[]}) {
  messengerStore.mainStore = mainStore
  dataCenter.limit = limit
  await initForNewUser()
  mainStore.watch.subscribe(mainStore.TOKEN_CHANGED, async () => {
    await initForNewUser()
    await startMessengerController()
  })
  controller.watchMainStore()
}

export async function limitChatRoomIds (chatRoomIds: number[]) {
  dataCenter.limit = { chatRoomIds }
}

export async function startMessengerController () {
  if (messengerStore.initialized) {
    return
  }
  await messengerClient.reconnect()
  await dataCenter.init()
  await messengerStore.init()
}

export * from './controller'
export * from './messenger-store'
export * from './controller-pool'
export * from './vuex'
export * from './type'
export * from './utils'
